import { useCountries } from 'hooks/useCountries';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetCountryName = () => {
    const { t } = useTranslation();

    const countriesQuery = useCountries();

    const getTranslateKeyCountryNameByCode = (code: string) => {
        return 'COUNTRIES_BY_CODE.' + code;
    };

    const getTranslatedCountryName = useCallback(
        (code: string) => {
            return t(getTranslateKeyCountryNameByCode(code) as keyof typeof t);
        },
        [t]
    );

    return { getTranslatedCountryName };
};
